import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/products/powerocean-single-phase';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';
import PoweroceanSinglePhase from '@elem/compPage/PoweroceanSinglePhase';

export default function OceanProHomeSolarBatteryPage({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();

    const { t } = useLang('PoweroceanSinglePhase');

    const router = useRouter();

    const { locale } = router;

    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    return (
        <PageLayout isNoFixed hideToTop theme="black">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <PoweroceanSinglePhase />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: { locale: string }) {
    if (!seoconfig.include.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
